import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import "./HomeLayout.scss";
import { useSiteContext } from "../../contexts/SiteProvider";
import { LOGO } from "../../services/ImageService";

const HomeLayout: React.FC = () => {
  const { settings } = useSiteContext();

  const getSiteLogo_left = () => {
    if (settings && settings.exam_left_logo) {

        let img_content = settings.exam_left_logo;
      
        if (typeof img_content === "string") {
            try {
                img_content = JSON.parse(img_content);
            } catch (error) {
                return LOGO;
            }
        }

        if (img_content?.type && img_content?.content) {
            return `data:${img_content.type};base64,${img_content.content}`;
        }
    }

    return LOGO;
};
    const getSiteLogo_right = () => {
      if (settings && settings.exam_right_logo) {
  
          let img_content = settings.exam_right_logo;
        
          if (typeof img_content === "string") {
              try {
                  img_content = JSON.parse(img_content);
              } catch (error) {
                  return ;
              }
          }
  
          if (img_content?.type && img_content?.content) {
              return `data:${img_content.type};base64,${img_content.content}`;
          }
      }
  
      return ;
  };
   const location = useLocation();

 
  const hideHeaderFooter = location.pathname === "/exam/exam";
  return (
    <div>
 {!hideHeaderFooter && (
    <motion.div
      className="main-header has-text-white has-text-centered online-exam-header"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    > <div className="is-flex is-justify-content-space-between">
    <div className="logo-right-container">
        <img
            className="is-rounded"
            src={getSiteLogo_left()}
            alt=" "
          />
        </div> <div className="has-text-weight-bold  mt-3"> {settings?.exam_title} </div>
        <div className="logo-right-container">
        <img
            className="is-rounded"
            src={getSiteLogo_right()}
            alt=" "
          />
        </div>
    </div>
    </motion.div>)}

    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <Outlet />
    </motion.div>

    {/* Footer Animation */}
    <motion.div
      className="main-footer has-text-white online-exam-header"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
     <p className="has-text-weight-bold">{settings?.exam_footer}</p> 
    </motion.div>
  </div>
  );
};

export default HomeLayout;